// The Imprest category reshapes Cash / UPI / Payment Line forms into an employee advance.
export const imprestCategoryId = (categories) => (categories || []).find((c) => c.name.trim().toLowerCase() === "imprest")?.id;
export const isImprestCategory = (categories, categoryId) => !!categoryId && categoryId === imprestCategoryId(categories);

// Hidden fields are cleared when Imprest is chosen; switching back starts them blank.
export const reshapeForCategory = (form, categories, categoryId) => {
  const imprest = isImprestCategory(categories, categoryId);
  const wasImprest = isImprestCategory(categories, form.category_id);
  const next = { ...form, category_id: categoryId };
  if (imprest && !wasImprest) {
    Object.assign(next, { site_id: "", equipment_id: "", vendor_code: "", vendor_bill_id: "", bill_amount_applied: "", payee_type: "Employee", payee_employee_id: "", payee_note: "" });
  } else if (!imprest && wasImprest) {
    Object.assign(next, { payee_type: "Other", payee_employee_id: "", payee_note: "" });
  }
  return next;
};
